export const EventVODStatus = {
	UPLOADING:        'uploading',
	UPLOADED:         'uploaded',
	UPLOAD_CANCELLED: 'upload_cancelled',
	VERIFYING:        'verifying',
	FINALIZING:       'finalizing',
	ENCODING:         'encoding', // avc 3q encoding started
	INAPPLICABLE:     'inapplicable', // default state
	BUILDING:         'building', // video cloud task running
	PROCESSING:       'processing', // external processing (3q) running
	NO_SIGNAL:        'no_signal', // no signal received, final state
	AVAILABLE:        'available', // fully available, final state
	FAILURE:          'failure', // failed, final state
};
